import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import useNonPaginatedRegisters from '@/modules/NonPaginatedRegisters.js'
import { ref } from 'vue'

const non_paginated_machine_capacities = ref([])
const machine_capacities = ref([])
const total_machine_capacities = ref(0)
const machine_capacity_filters = ref({})
const loading = ref(false)

export default function useMachineCapacities() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  search_and_paginate_api_path.value =
    '/api/machine_capacities/searchAndPaginate'
  get_api_path.value = '/api/machine_capacities/get/'
  save_api_path.value = '/api/machine_capacities/storeOrUpdate'
  destroy_api_path.value = '/api/machine_capacities/destroy/'

  const listMachineCapacities = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, machine_capacity_filters.value)
        .then((response) => {
          total_machine_capacities.value = response.data.meta.total
          machine_capacities.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyMachineCapacity = async (id, index) => {
    destroyRegister(id).then(() => {
      machine_capacities.value.splice(index, 1)
    })
  }

  const { all_registers_api_path, listRegisters: listRegistersNoPagination } =
    useNonPaginatedRegisters()

  all_registers_api_path.value = '/api/machine_capacities/all'

  const listMachineCapacitiesNoPagination = async () => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then((response) => {
          non_paginated_machine_capacities.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
    })
  }

  const listMachineCapacitiesNoPaginationToCompany = async (company_id) => {
    return new Promise((resolve, reject) => {
      listRegistersNoPagination()
        .then((response) => {
          non_paginated_machine_capacities.value = response.data.data.filter(
            (x) => x.company_id === company_id,
          )
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
    })
  }

  return {
    machine_capacities,
    non_paginated_machine_capacities,
    listMachineCapacitiesNoPagination,
    total_machine_capacities,
    machine_capacity_filters,
    loading,
    listMachineCapacitiesNoPaginationToCompany,
    listMachineCapacities,
    destroyMachineCapacity,
    getAllMachineCapacities: getAllRegisters,
    saveMachineCapacity: saveRegister,
    getMachineCapacity: getRegister,
  }
}
